import http from '@/utils/http'

export default {
  // 资讯文章列表接口
  getArticleList (params) {
    return http.get('/promotion/v1/api/weChatArticle/recommend/provider?pageNo=' + params.pageIndex + '&pageSize=' + params.pageSize +
      '&title=' + params.title + '&type=' + params.type
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/article/api/index.js